import axios from "axios";
export default {
  async getSubscriptionDetail(orgCode) {
    try {
      let headers = { "Content-Type": "application/json" };

      let response = await axios({
        method: "GET",
        url: "https://admin.iot.sigsenz.com/api/Subscription/Org/" + orgCode,
        headers: headers,
      });

      return response;
    } catch(ex){ console.error(ex)}
  },
};
